//subscription_product_id = "3616940357";
//ongoing_monthly = "17017847237";
//ongoing_monthly_gift = "27495102409";
//ongoing_annual = "17024183621";
//gift 3 months = 17017577477
//gift 6 months = 17017767557
//gift 12 months = 17017789701
var subscriptions_variant_ids = [
  "3616940357",
  "17017847237",
  "17024183621",
  "17017577477",
  "17017767557",
  "27495102409",
  "17017789701"
];

//digital_ongoing_monthly = "17662592005";
//digital_ongoing_annual = "17662591941";  
var subscriptions_variant_ids_digital = [
"17662592005",
"17662591941"
];

//Holstee Subscription Welcome Kit = 17072447749
//Holstee Subscription Welcome = 17072449349
var free_kit = [
"17072447749",
"17072449349"
];

var has_subscription_items = 0;
var has_regular_products = 0;
var free_product_already_added = 0;
var has_subscription_items_digital_only = 0;

$(".button button--primary").html('Save');


$(document).ready(function(){

  
  var variants_id = [];    
    $('#can-frame-variants-id li').each(function(){
      var val = $(this).text();
        variants_id.push(val);
    });
    
  var frame_variant_id = [];
  $('#select-frame > option').each(function() {
      var val = $(this).val();
      frame_variant_id.push(val);
  });
  
  $('#select-frame').change(function() {
    var frame_image = $('option:selected', this).attr('frm-img');
    //alert(frame_image);
    $('#popup-frame-img img').attr('src', frame_image);
  });

    $('.mini-cart__footer .button[name=upsell_open]').click(function(e){
      e.preventDefault();
    
      $('#mini-frame-note').html($('#mini-cart-note').html());
      
      //Call hotjar
      hj('vpv', '/mini-cart-continue-checkout/');
      
      var cart_variants = [];
      $('ul.mini-cart__items li').each(function(){
        var val = $(this).data('variant');
        cart_variants.push(val);
      });
      
      var need_frame = 0;
      cart_variants.filter(function(element){     
        if(variants_id.indexOf(''+element+'') > -1){
          need_frame++;
        }  
      });
      
      var frame_already_added = 0;
       cart_variants.filter(function(element){     
          if(frame_variant_id.indexOf(''+element+'') > -1){
              frame_already_added++;
          }  
        });

      if(need_frame > 0 && frame_already_added == 0){
        var frame_upsell = $('#frame_upsell');
        var mini_cart = $('.mini-cart__content');
        frame_upsell.show();
        mini_cart.hide();
      
        return false;
      }else{         
         $('#mini_add_frame .no-thanks').trigger('click');
      }
      
    });

    
  $('form[name="add_frame"] button[type=submit]').click(function(e){
      e.preventDefault();    
      var variant_id = $('#select-frame')[0].value;
      var msj = $('#msj-add');
      
      if(variant_id == ""){        
        msj.removeClass('add-frame-success');
        msj.addClass('add-frame-error');
        msj.fadeIn(1000);
        msj.text('Choose a product please');
        
        
        setTimeout(function(){
          msj.fadeOut(1000);  
        },2500);
          
        return false;
      }else{
        msj.removeClass('add-frame-error');
        msj.addClass('add-frame-success');
        msj.fadeIn(1000);
        msj.text('The frame has been added');
        
        //Call hotjar
        hj('vpv', '/mini-cart-add-frame/');
        
        setTimeout(function(){
          msj.fadeOut(1000);  
        },2500);
      }      
      
      jQuery.post('/cart/add.js', {
        quantity: 1,
        id: variant_id,
      });
      
      if (check_subscription()){
        //CartJS.addItem("17072449349", 1); 
        free_product_already_added = 1; 
      }
      
      $(this).attr("disabled", "disabled");
      
           
      if (free_product_already_added){ 
        setTimeout(function(){      
           $('#mini_add_frame .no-thanks').trigger('click');
          },3000);
      }else{ 
        $('#mini_add_frame .no-thanks').trigger('click');
      }
      
    });
  
  
    $('#mini_add_frame .no-thanks').click(function(e){       
   $(this).css({'cursor' : 'wait'});
      
      //Call hotjar
      hj('vpv', '/mini-cart-add-frame-no-thanks/');
      
      if (!free_product_already_added){
        $('ul.mini-cart__items > li').each(function() {
            var item_v_id = $(this).attr('data-variant');

            if (jQuery.inArray(item_v_id, subscriptions_variant_ids ) >= 0){
              has_subscription_items = 1;
            }else{
              has_regular_products = 1;
            }

            if (jQuery.inArray(item_v_id, subscriptions_variant_ids_digital ) >= 0){
              has_subscription_items_digital_only = 1;
            }

            if (jQuery.inArray(item_v_id, free_kit ) >= 0){
              free_product_already_added = 1;
            }

          });        

       
      }
    });
  
    
    $('form[name="add_frame"] button[name=cancel]').click(function(e){ 
        e.preventDefault();
      $(this).attr("disabled", "disabled");
      $('#mini_add_frame').submit();
       //window.location.href = "/cart?checkout";
      
      
      /*
      var frame_upsell = $('#frame_upsell');
        var mini_cart = $('.mini-cart__content');
        frame_upsell.hide();
        mini_cart.show();  
      */
    });

    //Getting info from url and assiging to the fields.
    var urlHere    = window.location.href,     // Returns full URL
      checkAban  = urlHere.indexOf('Abandoned+Cart+Follow+up'),
      checkUrl   = urlHere.indexOf('www.holstee.com/collections/subscription'),
      checkUrl2  = urlHere.indexOf('name='),
      checkUrl3  = urlHere.indexOf('email='),
      checkUrl4    = urlHere.indexOf('#ready-subscription');
    if(checkUrl >= 0 && checkUrl2 >= 0 && checkUrl3 >=0 && checkUrl4 >= 0)
    {
      if(checkAban >= 0)
      {
        var name = urlHere.substring(urlHere.lastIndexOf("&name=")+6,urlHere.lastIndexOf("&utm_medium="));
        var email = urlHere.substring(urlHere.lastIndexOf("&email=")+7,urlHere.lastIndexOf("&utm_source="));
        if(email.indexOf('%40') >= 0)
        {
          email = email.replace('%40','@');
        }
        $('#subscription-firstname').val(name);
        $('#subscription-email').val(email);
      }
      else
      {
        var name = urlHere.substring(urlHere.lastIndexOf("?name=")+6,urlHere.lastIndexOf("&email="));
        var email = urlHere.substring(urlHere.lastIndexOf("&email=")+7,urlHere.lastIndexOf("#ready-subscription"));
        $('#subscription-firstname').val(name);
        $('#subscription-email').val(email);
      }
    }
  
});


function check_subscription(){
  $('ul.mini-cart__items > li').each(function() {
            var item_v_id = $(this).attr('data-variant');

            if (jQuery.inArray(item_v_id, subscriptions_variant_ids ) >= 0){
              has_subscription_items = 1;
            }else{
              has_regular_products = 1;
            }

            if (jQuery.inArray(item_v_id, subscriptions_variant_ids_digital ) >= 0){
              has_subscription_items_digital_only = 1;
            }

            if (jQuery.inArray(item_v_id, free_kit ) >= 0){
              free_product_already_added = 1;
            }

          });        

        
  return false;
}


    
